import React, { useEffect, useState } from "react";

import { ReactComponent as SmallEllips } from "../../assets/landingPages/Ellipse 2.svg";

import MainImg from "../../assets/landingPages/aboutMainImg.png";
import OgImage from "../../assets/landingPages/homePage/Hero.png";
import BulerImg from "../../assets/landingPages/abouHeroBlur.png";
import HeroEllipseGroup from "../../assets/landingPages/aboutHeroEllipsGroup.png";
import UserOne from "../../assets/landingPages/teamMembers/teamOne.png";
import UserTwo from "../../assets/landingPages/teamMembers/userTwo.png";
import UserThree from "../../assets/landingPages/teamMembers/userThree.png";
import UserFourth from "../../assets/landingPages/teamMembers/userFourth.png";
import User5 from "../../assets/landingPages/teamMembers/userFifth.png";
import User6 from "../../assets/landingPages/teamMembers/userSix.png";
import User7 from "../../assets/landingPages/teamMembers/userSeven.png";
import User8 from "../../assets/landingPages/teamMembers/userEight.png";
import User9 from "../../assets/landingPages/teamMembers/userNine.png";
import User10 from "../../assets/landingPages/teamMembers/userTen.png";
import User11 from "../../assets/landingPages/teamMembers/userEleven.png";
import User12 from "../../assets/landingPages/teamMembers/user12.png";
import TeamTwitter from "../../assets/landingPages/teamtwitter.png";
// import TeamIn from "../../assets/landingPages/teamIn.png";
import { ReactComponent as LinkedIn } from "../../assets/landingPages/Linkedin.svg";
import { ReactComponent as Twitter } from "../../assets/landingPages/Twitter.svg";
// import DownArrowIcon from "../../assets/landingPages/DownArrow.png";
import DownArrowIcon from "../../assets/landingPages/arrow-down.svg";
import DownArrowIconDark from "../../assets/landingPages/arrow-down-dark.svg";
import useLocales from "../../hooks/useLocales";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";

//Team member card component define
const TeamMemberCard = ({ user }) => {
  return (
    <div className="p-0 max-w-fit">
      <div className="flex justify-center items-center">
        <img
          className="h-[280px] w-[250px] object-cover rounded-lg"
          src={user.image}
          alt="..."
          title="..."
        />
      </div>
      <div className="p-2 pt-2.5">
        <div className="flex justify-between items-start">
          <div>
            <h6 className="text-body_copy2_black text-heading_color dark:text-color_v1_dark capitalize">
              {user.name}
            </h6>
            <p className="text-start text-small2 text-body_copy_medium_color dark:text-color_v2_dark capitalize">
              {" "}
              {user.post}{" "}
            </p>
          </div>
          {/*   <div className="flex items-center gap-2">
            <img className="h-7 w-7" src={TeamTwitter} alt="..." title="..." />
            <img className="h-7 w-7" src={TeamIn} alt="..." title="..." />
            </div> */}
          <div className="flex items-center gap-2">
            <Twitter className="h-7 w-7" />
            <LinkedIn className="h-7 w-7" />
          </div>
        </div>
      </div>
    </div>
  );
};

const AboutPage = () => {
  const { translate, currentLang } = useLocales();

  const { darkMode } = useSelector((state) => state.theme);
  //Team members data here
  const users = [
    {
      image: UserOne,
      name: translate("header.name"),
      post: translate("header.post"),
    },
    {
      image: UserTwo,
      name: translate("header.name"),
      post: translate("header.post"),
    },
    {
      image: UserThree,
      name: translate("header.name"),
      post: translate("header.post"),
    },
    {
      image: UserFourth,
      name: translate("header.name"),
      post: translate("header.post"),
    },
    {
      image: User5,
      name: translate("header.name"),
      post: translate("header.post"),
    },
    {
      image: User6,
      name: translate("header.name"),
      post: translate("header.post"),
    },
    {
      image: User7,
      name: translate("header.name"),
      post: translate("header.post"),
    },
    {
      image: User8,
      name: translate("header.name"),
      post: translate("header.post"),
    },
    {
      image: User9,
      name: translate("header.name"),
      post: translate("header.post"),
    },
    {
      image: User10,
      name: translate("header.name"),
      post: translate("header.post"),
    },
    {
      image: User11,
      name: translate("header.name"),
      post: translate("header.post"),
    },
    {
      image: User12,
      name: translate("header.name"),
      post: translate("header.post"),
    },
  ];

  const [showAll, setShowAll] = useState(false);
  const [width, setWidth] = useState(null);
  const [initialItemCount, setInitialItemCount] = useState(4);
  useEffect(() => {
    if (width < 768) {
      setInitialItemCount(4);
    } else {
      setInitialItemCount(users.length);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width]);

  const updateDimensions = () => {
    setWidth(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    updateDimensions();

    return () => window.removeEventListener("resize", updateDimensions);
  }, []);
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>About Us | Bil.Bio</title>
        <meta property="og:title" content="About Us | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content={currentLang?.value} />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>
      <section className="-mt-[93px]  bg-[#fbf7f7] dark:bg-dark-primary pt-[93px]">
        <img
          className="absolute top-0 left-0 h-[18rem] sm:h-[30rem]"
          src={HeroEllipseGroup}
          alt="..."
          title="..."
        />
        <div className="flex justify-center ">
          <div className="max-w-screen-2xl w-full">
            <div className="relative px-3 xsmm:px-6 smm:px-8 sm:px-16 lg:px-16 xl:px-24 py-[50px] pt-[60px] sm:pt-[80px] sm:py-[80px]">
              <img
                className="z-0 absolute xsmfold:right-0 smm:right-0 sm:right-4 xsmfold:top-12 smm:-top-0 sm:-top-8 xsmfold:h-[12rem] smm:h-[14rem] sm:h-[20rem] lg:right-16 lg:-top-12 lg:h-[30rem] xl:right-20 xl:-top-12 xl:h-[40rem] "
                src={BulerImg}
                alt="..."
                title="..."
              />
              <div className="flex justify-center">
                <div className="text-center xl:w-3/5 2xl:px-14">
                  <h1 className="text-custom_h4 sm:text-custom_h3 lg:text-custom_h1 mb-5 dark:text-color_v1_dark">
                    {/* About Us */}
                    {translate("header.about_us")}
                  </h1>
                  <div className="text-small2 sm:text-small1 lg:text-body_copy1 text-body_copy_medium_color dark:text-color_v2_dark">
                    <p className="hidden lg:block">
                      {/* Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry.Lorem Ipsum has been the industry 's
                      standard dummy text ever since the 1500 s, when an unknown
                      printer took a galley of type and scrambled it to make a
                      type specimen book.It has survived not only five
                      centuries, but also the leap into electronic typesetting,
                      remaining essentially unchanged.It was popularised in the
                      1960 s with the release of Letraset sheets containing
                      Lorem Ipsum. */}
                      {translate("front_end_pages.about.description_text")}
                    </p>
                    <p className="block lg:hidden">
                      {/* Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry.Lorem Ipsum has been the industry 's
                      standard dummy text ever since the 1500 s, when an unknown
  printer took a galley. */}
                      {translate(
                        "front_end_pages.about.description_text_mobile"
                      )}
                    </p>
                  </div>

                  <div className="text-center flex justify-center ">
                    <Link
                      to={"/contact"}
                      className="z-50 text-small2_b border-dark_bg_v2 dark:border-color_v2_dark text-dark_bg_v2 dark:text-color_v2_dark border  rounded-full text-center pt-[9px] p-2 px-[26px] cursor-pointer mt-6 md:mt-8 mb-10 md:mb-[60px]"
                    >
                      {/* GET IN TOUCH */}
                      {translate("front_end_pages.about.get_in_touch")}
                    </Link>
                  </div>
                </div>
              </div>
              <div className="flex justify-center items-center">
                <div className="relative">
                  <SmallEllips className="absolute  xsmfold:-right-3 smm:-right-5 sm:-right-8 lg:-right-8 xl:-right-12 xsmfold:top-4 xsml:top-5 smm:top-5 sm:top-4 md:top-8 lg:top-14 xl:top-12 xsmfold:w-10 smm:w-16 sm:w-20 lg:w-24 xl:w-[150px] xsmfold:h-10 smm:h-16 sm:h-20 lg:h-24 xl:h-[150px] z-0 " />
                  <div className="z-10">
                    <img
                      className="z-10 relative"
                      src={MainImg}
                      alt="..."
                      title="..."
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-center dark:bg-dark-primary">
          <div className="max-w-screen-2xl w-full">
            <div className="px-5 py-10 sm:pb-[149px]">
              <div className="text-center">
                <h6 className="text-[#FF5349] text-caption2 sm:text-caption mb-2 md:mb-1 uppercase">
                  {/* TEAM */}
                  {translate("front_end_pages.about.team")}
                </h6>
                <h3 className="text-custom_h5 sm:text-custom_h4 lg:text-custom_h3 text-gray-800 dark:text-color_v1_dark mb-[29px] md:mb-[60px]">
                  {/* Meet Our Amazing */}
                  {translate("front_end_pages.about.meet_our_amazing")}
                  <br className="sm:hidden" />
                  <span className="text-[#FF5349]">
                    {translate("front_end_pages.about.team")}
                  </span>
                </h3>

                <div className="grid grid-cols-1 smm:grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 gap-[30px] md:gap-[57px] smm:px-5 sm:px-7 lg:px-40 xl:px-48 justify-center items-center">
                  {users
                    .slice(0, showAll ? users.length : initialItemCount)
                    .map((user, i) => {
                      return (
                        <div
                          key={i}
                          className={`flex justify-center ${
                            i >= initialItemCount && !showAll
                              ? "hidden sm:block"
                              : ""
                          }`}
                        >
                          <TeamMemberCard user={user} />
                        </div>
                      );
                    })}
                </div>
                {!showAll &&
                  window.innerWidth < 768 &&
                  users.length > initialItemCount && (
                    <div className="text-center flex justify-center">
                      <button
                        className="text-dark_bg_v2 dark:text-color_v2_dark border-dark_bg_v2 dark:border-color_v2_dark border uppercase rounded-full flex items-center text-center justify-center gap-2 text-small2_b pt-[9px] p-2 px-[26px] cursor-pointer mt-10 mb-7"
                        onClick={() => setShowAll(true)}
                      >
                        {translate("front_end_pages.about.view_all")}{" "}
                        <img
                          src={darkMode ? DownArrowIconDark : DownArrowIcon}
                          alt="..."
                          title="..."
                        />
                      </button>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutPage;
